const PT = "America/Los_Angeles";

/** YYYY-MM-DD of an ISO timestamp in Pacific time (the backup job's clock). */
export const nightOf = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: PT });

/** The last `n` Pacific calendar dates, oldest first. */
export const lastNights = (n) => {
  const out = [];
  for (let i = n - 1; i >= 0; i -= 1) out.push(nightOf(new Date(Date.now() - i * 86400000).toISOString()));
  return out;
};

/** Best status per night: ready beats failed beats running/none. */
export const nightStatus = (rows) => {
  const byNight = {};
  for (const r of rows) {
    const k = nightOf(r.created_at);
    const rank = { ready: 3, failed: 2, running: 1 }[r.status] || 0;
    if (rank > (byNight[k]?.rank || 0)) byNight[k] = { rank, status: r.status, row: r };
  }
  return byNight;
};

export const fmtSize = (n) => (n == null ? "—" : n < 1048576 ? `${Math.max(1, Math.round(n / 1024))} KB` : `${(n / 1048576).toFixed(1)} MB`);

export const fmtWhen = (iso) =>
  new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const expiryLabel = (iso) => {
  if (!iso) return "—";
  const days = Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000);
  if (days <= 0) return "expired";
  return days === 1 ? "expires tomorrow" : `expires in ${days}d`;
};

export const nightLabel = (ymd) =>
  new Date(`${ymd}T12:00:00`).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" });
